export const vehicleNumberGroups = {
  'default': ['vehicle'],
  'temporary': ['temporary'],
  'permanent': ['vehicle', 'trailer', 'vr', 'mvs', 'diplomatic', 'military'],
  'all': ['temporary', 'vehicle', 'trailer', 'vr', 'mvs', 'diplomatic', 'military'],
};
